<template>
	<div>
		<el-tabs type="border-card" v-model="tabs" @tab-remove="Tabremove">
			<el-tab-pane label="商品管理"  name="lie" >
				<el-collapse>
					<el-collapse-item title="筛选">
						<el-form ref="form" :model="so" label-width="80px" style="margin-left: 80px;">
							<el-form-item label="关键字">
								<el-input v-model="so.guanjianci"></el-input>
							</el-form-item>
							<el-form-item label="状态">
								<el-select v-model="so.zhuangtai" placeholder="请选择状态" style="width: 100%;">
									<el-option label="不限" value=""></el-option>
									<el-option label="上架" value="1"></el-option>
									<el-option label="下架" value="0"></el-option>
									<el-option label="待审核" value="5"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="分类">
								<Liandong :yiji.sync="so.yiji" :erji.sync="so.erji" :shu="fenleilie"></Liandong>
							</el-form-item>
							<Tijiao @click="CSH" size="medium" type="info" style="margin-left: 80px;">搜索</Tijiao>							
						</el-form>
					</el-collapse-item> 
				</el-collapse>

				<el-table :data="lie" style="width: 100%" stripe>
					<el-table-column prop="id" label="ID" width="80"></el-table-column>
					<el-table-column label="排序" width="80">
						<template slot-scope="shu">
							<el-input style="width: 100%;" size="small" v-model="shu.row.paixu"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="商品" width="400" style="position: relative;display: flex;">
						<template slot-scope="shu">
							<el-image style="width: 50px; height:50px; margin-right:16px;" :src="shu.row.tu" fit="cover"></el-image>
						<div style="">
						<div style="display: flex;">
							 <!-- position: absolute; top:10px; left: 60px; -->
							<span class="leixin" v-if="shu.row.fenlei_yiji">【{{shu.row.fenlei_yiji_ming}}】</span>
							<span class="leixin2" v-if="shu.row.fenlei_erji">【{{shu.row.fenlei_erji_ming}}】</span>
							<span class="leixin3" v-if="shu.row.shanghuming">
							<el-image  class="leixin5" src="http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_10/geLtMywtdbTTEmtNN1wL6552mWYbDE.png" fit="cover"></el-image>
							{{shu.row.shanghuming}}</span>
							<el-tag type="danger" class="zhuantai" effect="dark" size="mini" v-if="shu.row.cuxiao==1">拼</el-tag>
							</div>
							<span class="leixin4">{{shu.row.ming}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="zhanghao" label="商品属性" width="300">
						<template slot-scope="shu">
							<span class="eltag el-tag el-tag--dark" :class="(shu.row.xinpin==1)?'':'el-tag--info'" @click="Biaoqian(shu.row,'xinpin',1)">新品</span>
							<span class="eltag el-tag el-tag--dark" :class="(shu.row.tuijian==1)?'':'el-tag--info'" @click="Biaoqian(shu.row,'tuijian',1)">推荐</span>						
							<span class="eltag el-tag el-tag--dark" :class="(shu.row.miaosha==1)?'':'el-tag--info'" @click="Biaoqian(shu.row,'miaosha',1)">秒杀</span>
						</template>
					</el-table-column>
					<el-table-column prop="" label="价格/原价/库存">
						<template slot-scope="shu">
							<span>{{shu.row.jiage}}元/</span>
							<span>{{shu.row.yuanjia}}元/</span>
							<span>{{shu.row.kucun}}个</span>
						</template>
					</el-table-column>
					<el-table-column label="发布/更新时间">
						<template slot-scope="shu">
							<div>{{shu.row.shijian}}</div>
							<div>{{shu.row.gengxinshijian}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="shenghe" label="状态" width="120">
						<template slot-scope="shu">
							<el-button size="small" type="success" @click="Shangxiajia(shu.row)" v-if="shu.row.zhuangtai==1">上架</el-button>
							<el-button size="small" type="success" @click="Shangxiajia(shu.row)" v-else-if="shu.row.zhuangtai==5">待审核</el-button>
							<el-button size="small" type="info" @click="Shangxiajia(shu.row)" v-else="shu.row.zhuangtai==0">下架</el-button>
						</template>
					
					</el-table-column>
					<el-table-column  label="操作">
						<template slot-scope="shu">
							<el-button  icon="el-icon-edit-outline" size="small" @click="Bianji(shu.row)"></el-button>
							<el-button  icon="el-icon-close" size="small"  @click="Shanchu(shu.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
                <el-pagination background layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao" :current-page.sync="so.ye" @current-change="CSH" style="margin-top: 30px;"/>
              
			</el-tab-pane>
			<el-tab-pane :label="shu.id?'编辑商品':'新增商品'" name="xinzeng" :closable="shu.id>0">
				<el-tabs>
					<!-- 基本信息 -->
					<el-tab-pane label="基本信息">
						<el-form :model="shu">							
							<el-form-item label="标题" label-width="100px">
								<el-input v-model="shu.ming"></el-input>
							</el-form-item>
							<el-form-item label="分类" label-width="100px">
								<Liandong :yiji.sync="shu.fenlei_yiji" :erji.sync="shu.fenlei_erji" :shu="fenleilie" v-if="shu && fenleilie"></Liandong>
							</el-form-item>
							<el-form-item label="绑定商户" label-width="100px">
								<Shanghu :id.sync="shu.shanghu" :ming.sync="shu.shanghuming"></Shanghu>							
							</el-form-item>
							<el-form-item label="单位" label-width="100px">
								<el-input placeholder="商品单位,如:个/件" v-model="shu.danwei" />
							</el-form-item>
							<el-form-item label="标签" label-width="100px">
								<el-tag :type="(shu.xinpin==1)?'':'info'" effect="dark" class="eltag" @click="Biaoqian(shu,'xinpin')">新品</el-tag>
								<el-tag :type="(shu.tuijian==1)?'':'info'" effect="dark" class="eltag" @click="Biaoqian(shu,'tuijian')">推荐</el-tag>							
								<el-tag :type="(shu.miaosha==1)?'':'info'" effect="dark" class="eltag" @click="Biaoqian(shu,'miaosha')">秒杀</el-tag>									
							</el-form-item>
							<el-form-item label="秒杀时间" v-if="shu.miaosha==1" label-width="100px">
								<el-date-picker v-model="shu.miaoshashijian" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>							
							<el-form-item label="商品专区" label-width="100px">
								<el-radio-group v-model="shu.cuxiao">
									<el-radio-button label="0">普通</el-radio-button>
									<el-radio-button label="1">拼团</el-radio-button>
									<el-radio-button label="2">兑换</el-radio-button>
									<el-radio-button label="3">砍价</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="商品主图" label-width="100px">
								<Shangwenjian v-model="shu.tu" anniu="上传图片" leixing="tu"></Shangwenjian>							
							</el-form-item>
							<el-form-item label="小视频" label-width="100px">
								<Shangwenjian v-model="shu.shipin" anniu="上传小视频" leixing="yinpin"></Shangwenjian>
							</el-form-item>
							<el-form-item label="细节图" label-width="100px">
								<Shangtu v-model="shu.xijietu" shuliang="5" v-if="tabs=='xinzeng'"></Shangtu>
							</el-form-item>
							<el-form-item label="商品价格" label-width="100px">
								<el-input placeholder="请输入售价" v-model="shu.jiage">
									<template slot="prepend">售价</template>
									<template slot="append">元</template>
								</el-input>
								<!-- 拼团 -->
								<!-- <el-input placeholder="请输入内容" style="width:40%;" v-show="index==2">
									<template slot="prepend">拼团价</template>
									<template slot="append">元</template>
								</el-input>
								<el-input placeholder="请输入内容" style="width:40%;" v-show="index==2">
									<template slot="prepend">人数</template>
									<template slot="append">人</template>
								</el-input> -->
								<!-- 砍价 -->
								<!-- <template>
									<el-input placeholder="请输入内容" style="width:33%;" v-show="index==4">
										<template slot="prepend">砍价</template>
										<template slot="append">元</template>
									</el-input>
									<el-input placeholder="请输入内容" style="width:33%;" v-show="index==4">
										<template slot="prepend">人数</template>
										<template slot="append">人</template>
									</el-input>
									<el-input placeholder="请输入内容" style="width:33%;" v-show="index==4">
										<template slot="prepend">最低砍至</template>
										<template slot="append">元</template>
									</el-input>
								</template> -->
								<!-- 普通 -->
								<el-input placeholder="请输入原价" style="margin-top: 20px;" v-model="shu.yuanjia">
									<template slot="prepend">原价</template>
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
							<el-form-item label="重量" label-width="100px">
								<el-input placeholder="请输入重量" v-model="shu.zhongliang">
									<template slot="append">克</template>
								</el-input>
							</el-form-item>
							<el-form-item label="库存" label-width="100px">
								<el-input placeholder="请输入库存" v-model="shu.kucun">
									<template slot="append">{{shu.danwei?shu.danwei:'个'}}</template>
								</el-input>
							</el-form-item>
							<el-form-item label="单次购买量" label-width="100px">
								<el-input placeholder="单次最多购买商品数量" v-model="shu.yicizuiduomai">
									<template slot="append">{{shu.danwei?shu.danwei:'个'}}</template>
								</el-input>
							</el-form-item>
							<el-form-item label="最多购买量" label-width="100px">
								<el-input placeholder="用户最多购买该商品数量,超出不可再购买" v-model="shu.zuiduomai">
									<template slot="append">{{shu.danwei?shu.danwei:'个'}}</template>
								</el-input>
							</el-form-item>
							<el-form-item label="赠送积分" label-width="100px">
								<el-input placeholder="购买该商品赠送积分" v-model="shu.jifen">
									<template slot="append">个</template>
								</el-input>
							</el-form-item>

							<el-form-item label="运费设置" label-width="100px">
								<el-select v-model="shu.kuaidi" placeholder="请选择运费模板" style="width:20%; margin-top: 4px;" size="small">
									<el-option label="包邮" :value="0"></el-option>
									<el-option v-for="l in kuaidilie" :label="l.ming" :value="l.id"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<Tijiao @click="Tijiao"></Tijiao>
							</el-form-item>
						</el-form>
					</el-tab-pane>
					<!-- 商品描述 -->
					<el-tab-pane label="商品描述">
						<Bianjiqi v-model="shu.xiangqing" ming="xiangqing"></Bianjiqi>
						<Tijiao @click="Tijiao"></Tijiao>
					</el-tab-pane>
					<!-- 自定义属性 -->
				<!-- 	<el-tab-pane label="自定义属性">
						<el-form ref="form" :model="form">
							<div style="display: flex;flex-wrap: nowrap; margin-left: 1.875rem;">
								<el-form-item v-for="l in shuXin" :label="l.label" label-width="" style="width: 30%;">
									<el-input style="width: 60%;"></el-input>
								</el-form-item>
							</div>
							<el-form-item>
								<el-button>添加属性</el-button>
							</el-form-item>
						</el-form>
					</el-tab-pane> -->
					<!--  商品规格-->
					<el-tab-pane label="商品规格">
						<span style="color: #606266; font-size: 14px;margin-left: 100px;margin-right: 20px;">是否启用商品规格</span>
						<el-checkbox v-model="shu.kaiqiguige">启用</el-checkbox>						
						<Guige :shu.sync="shu.guige" :guigezu.sync="shu.guigezu" style="margin-top: 40px;"></Guige>	
						<Tijiao @click="Tijiao" ></Tijiao>						
					</el-tab-pane>
					<!-- 会员权限 -->
					<el-tab-pane label="会员权限">
						<el-form ref="form" :model="shu">
							<el-form-item label="会员角色购买权限" label-width="180px">
								<el-radio-group v-model="shu.goumaiquanxian">
									<el-radio label="0" >不限</el-radio>
									<el-radio :label="l.id" v-for="l in dengJilie">{{l.ming}}</el-radio>	
								</el-radio-group>
							</el-form-item>
							<el-form-item label-width="80px">
								<el-tag>只有当折扣大于0的情况下才能生效，否则按自身会员角色折扣计算</el-tag>
							</el-form-item>
							<el-form-item label="会员角色折扣" label-width="180px">
								<el-input placeholder="请输入折扣" v-model="shu.zhekou[i]" size="small" v-for="(l,i) in dengJilie">
									<template slot="prepend" size="small">{{l.ming}}</template>
									<template slot="append" size="small">折</template>
								</el-input>
							</el-form-item>
								<Tijiao @click="Tijiao" ></Tijiao>
						</el-form>
					
					</el-tab-pane>
					<!-- 营销 -->
					<el-tab-pane label="营销">
						<el-form  :model="shu">
							<el-form-item label="积分抵扣" label-width="180px">
								<el-input placeholder="设置可用积分进行抵扣的金额" v-model="shu.yingxiao.jifen" size="small">
									<template slot="prepend" size="small">最多抵扣</template>
									<template slot="append" size="small">个</template>
								</el-input>								
							</el-form-item>
							<el-form-item label-width="180px">
								<Tijiao @click="Tijiao" ></Tijiao>
							</el-form-item>
						</el-form>
						
					</el-tab-pane>
					<!-- 分销设置 -->
					<el-tab-pane label="分销设置">
						<el-form  :model="shu">
							<el-form-item label="是否参与分销" label-width="180px">
								<el-radio-group v-model="shu.canyufenxiao">
									<el-radio label="1">参与分销 </el-radio>
									<el-radio label="0">不参与分销</el-radio>
								</el-radio-group>
								<div class="tishi">如果不参与分销，则不产生分销余额</div>
								
							</el-form-item>
							<el-form-item label="购此商品分销角色升为：" label-width="180px">
								<el-radio-group v-model="shu.dengji">
									<el-radio label="0" >不升级</el-radio>
									<el-radio :label="l.id" v-for="l in dengJilie">{{l.ming}}</el-radio>	
								</el-radio-group>
							</el-form-item>
						<!-- 	<el-form-item label="独立规则：" label-width="180px">
								<el-radio v-model="radio" label="1">不启动独立余额</el-radio>
								<el-radio v-model="radio" label="2">启动独立余额</el-radio>
								<div class="tishi">启用独立余额设置，此商品拥有独自的余额比例,不受分销角色比例及默认设置限制</div>
							</el-form-item> -->
							<el-form-item label-width="180px">
								<Tijiao @click="Tijiao"></Tijiao>
							</el-form-item>
						</el-form>
					</el-tab-pane>
				</el-tabs>
			</el-tab-pane>
			
		</el-tabs>
	</div>
</template>

<script>
	let that;
	import Shangtu from '../../zujian/Shangtu.vue'
	import Bianjiqi from '../../zujian/Bianjiqi.vue'
	import Liandong from '../../zujian/Liandong.vue'
	import Huiyuan from '../../zujian/Huiyuan.vue'
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	import Guige from '../../zujian/Guige.vue'
	import Shanghu from '../../zujian/Shanghu.vue'
	export default {
		data() {
			return {
				shu: {				
					guige:[],
					guigezu:[],
					yingxiao:{},
					zhekou:[]				
				},
				fenleilie: [],
				so: {
					ye: 1,
					jitiao: 20
				},
				zongshu:0,
				lie: [],
				dengJilie: [],
				dengJilie_obj: [],
				tabs:'lie',	
				kuaidilie:[]
			}

		},
		created() {
			that = this;
			this.CSH();
			this.Dengjilie();
			this.Fenlei();
			this.Kuaidi();
			
		},
		components: {
			Shangtu,
			Bianjiqi,
			Liandong,
			Huiyuan,
			Shangwenjian,
			Guige,
			Shanghu
		},
		methods: {
			CSH() {
				this.$post('m=zw_shangcheng&k=shangpin', that.so, function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
				});
			},
			Dengjilie() {
				this.$post('k=huiyuan&c=dengjilie', function(s) {
					that.dengJilie_obj = s.shu;
					that.dengJilie=[];
					for (var i in s.shu) {
						that.dengJilie.push(s.shu[i])
					}
			
				});
			},
			Fenlei() {
				this.$post('m=zw_shangcheng&k=shangpin&c=quanbufenlei', function(s) {
					if (s.shi == 1) {
						that.fenleilie = s.shu;
					}
				});
			},
			Tijiao(){			
				this.$post('m=zw_shangcheng&k=shangpin&c=xiugai',that.shu,function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi){
						that.CSH();
						if(!that.shu.id){
							that.shu=[];
						}					
					}
				});
			},
			Bianji(e){
				that.shu=[];
				that.tabs='xinzeng';
				that.shu=e;
				console.log(e)
				
			},			
			Tabremove(e){
				that.tabs='lie';
				that.shu={				
					guige:[],
					guigezu:[],
					yingxiao:{},
					zhekou:[]					
				};
				
			},
			Shangxiajia(e){
				if(e.zhuangtai==1){
					e.zhuangtai=0;
				}else{
					e.zhuangtai=1;
				}
				this.$post('m=zw_shangcheng&k=shangpin&c=xiugai',{id:e.id,zhuangtai:e.zhuangtai},function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi){
						that.CSH();										
					}
				});
			},
			Shanchu(e){
				this.$post('m=zw_shangcheng&k=shangpin&c=shandiao',{id:e.id},function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi){
						that.CSH();										
					}
				});
			},
			Biaoqian(a,b,c){
				if(a[b]){
					a[b]=0;
				}else{
					a[b]=1
				}	
				if(c){
					var s={};
					s['id']=a.id;
					s[b]=a[b];
					this.$post('m=zw_shangcheng&k=shangpin&c=xiugai',s,function(s) {
						that.$xiaoxi(s.shu);					
					});
				}		
			},
			Kuaidi() {
				this.$post('k=kuaidi', that.so, function(s) {
					that.kuaidilie = s.shu.lie;					
				});
			},
			
			
		}
	}
</script>
<style scope>
	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.leixin {
		color: #f05050;
		/* position: absolute;
		top: 4px; */
	}

	.leixin2 {
		color: #4cb6cb;
		margin-left: -10px;
		/* position: absolute;
		top: 4px;
		left: 117px; */
	}
	.shangtu .el-upload--picture-card {
		width: 100px;
		height: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.leixin3 {
		color: #008000;
		display: block;
		display: flex;
	/* 	position: absolute;
		top: 4px;
		left: 169px; */
	}
	.leixin5{
		width: 19px;
		margin: 0 4px;
	}
	.leixin4 {
		    color: #788188;
		    width: 232px;
		    display: block;
		    line-height: 16px;
			margin-top: 9px;
			margin-left:6px;
		   /* position: absolute;
		    top: 38px;
		    left: 66px; */
		
	}

	.zhuantai {
		margin-left: 10px;
	}
	.eltag{
		margin-right: 5px;cursor: pointer;
	}
	.el-table_1_column_3 .cell{
		display: flex;
	}
</style>
